import React, { useRef, useLayoutEffect } from "react";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import am4themes_material from "@amcharts/amcharts4/themes/material";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";

am4core.useTheme(am4themes_animated);
am4core.useTheme(am4themes_material);

function Chart({ columnChartData }) {
  const chart = useRef(null);

  useLayoutEffect(() => {
    var x = am4core.create("columnChartDiv", am4charts.XYChart);

    x.data = columnChartData.arrOfObj;

    // Set input format for the dates
    x.dateFormatter.inputDateFormat = "yyyy-MM-dd";

    // Create axes
    var dateAxis = x.xAxes.push(new am4charts.DateAxis());
    // dateAxis.renderer.labels.template.location = 0.0001;
    dateAxis.renderer.minGridDistance = 20;
    dateAxis.renderer.labels.template.rotation = -60;
    dateAxis.renderer.labels.template.verticalCenter = "middle";
    dateAxis.renderer.labels.template.horizontalCenter = "middle";
    dateAxis.groupData = true;
    dateAxis.periodChangeDateFormats.setKey("month", "[bold]yyyy[/]");

    // https://www.amcharts.com/docs/v4/concepts/axes/date-axis/#Formatting_date_and_time
    dateAxis.groupIntervals.setAll([
      { timeUnit: "day", count: 1 },
      { timeUnit: "week", count: 1 },
      { timeUnit: "month", count: 1 },
      { timeUnit: "month", count: 4 },
      { timeUnit: "year", count: 1 },
      { timeUnit: "year", count: 10 },
    ]);

    dateAxis.baseInterval = {
      timeUnit: "day",
    };

    var valueAxis = x.yAxes.push(new am4charts.ValueAxis());
    dateAxis.groupIntervals.setAll([
      { timeUnit: "day", count: 1 },
      { timeUnit: "month", count: 1 },
      { timeUnit: "year", count: 1 },
      // { timeUnit: "year", count: 10 },
    ]);

    // Create series
    var series = x.series.push(new am4charts.ColumnSeries());
    series.dataFields.valueY = "count";
    series.dataFields.dateX = "date";
    series.strokeWidth = 15;
    // series.minBulletDistance = 15;
    series.connect = false;
    series.autoGapCount = 1;
    series.groupFields.valueY = "sum";
    series.columns.template.column.strokeWidth = 0;

    series.heatRules.push({
      target: series.columns.template,
      property: "fill",
      min: am4core.color("#12c2e9"),
      max: am4core.color("#f64f59"),
      dataField: "valueY",
      logarithmic: true,
    });

    const heatColors = [
      am4core.color("#12c2e9"),
      am4core.color("#c471ed"),
      am4core.color("#f64f59"),
    ];

    // custom function to get a three-color-heatmap
    series.columns.template.column.adapter.add("fill", function (fill, column) {
      const workingValue = column.dataItem.values["valueY"].workingValue;
      const minValue = series.dataItem.values["valueY"].low;
      const maxValue = series.dataItem.values["valueY"].high;
      const percent = (workingValue - minValue) / (maxValue - minValue);
      if (am4core.type.isNumber(percent)) {
        if (percent > 0.5) {
          return new am4core.Color(
            am4core.colors.interpolate(heatColors[1].rgb, heatColors[2].rgb, (percent - 0.5) * 2)
          );
        } else {
          return new am4core.Color(
            am4core.colors.interpolate(heatColors[0].rgb, heatColors[1].rgb, percent * 2)
          );
        }
      }
      return fill;
    });

    // Drop-shaped tooltips
    series.tooltipText = "{valueY}";
    series.tooltip.background.cornerRadius = 20;
    series.tooltip.background.strokeOpacity = 0;
    series.tooltip.pointerOrientation = "vertical";
    series.tooltip.label.minWidth = 40;
    series.tooltip.label.minHeight = 40;
    series.tooltip.label.textAlign = "middle";
    series.tooltip.label.textValign = "middle";

    // // Make a panning cursor
    x.cursor = new am4charts.XYCursor();
    x.cursor.behavior = "panXY";
    x.cursor.xAxis = dateAxis;
    x.cursor.snapToSeries = series;

    // Create vertical scrollbar and place it before the value axis
    x.scrollbarY = new am4core.Scrollbar();
    x.scrollbarY.parent = x.leftAxesContainer;
    x.scrollbarY.toBack();

    // Create a horizontal scrollbar with previe and place it underneath the date axis
    x.scrollbarX = new am4charts.XYChartScrollbar();
    x.scrollbarX.series.push(series);
    x.scrollbarX.parent = x.bottomAxesContainer;

    dateAxis.start = 0.79;
    dateAxis.keepSelection = true;

    valueAxis.start = 0;

    x.logo.disabled = true;
    chart.current = x;

    return () => {
      x.dispose();
    };
  }, [columnChartData]);

  return (
    <>
      <div id="columnChartDiv" style={{ maxWidth: "1000px", width: "100%", height: "500px" }} />
    </>
  );
}
export default Chart;
